module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Equalizer-38abff03030ebca817331f308363a0e0.svg";